const headerLinks = [
  {
    key: "overview",
    link: "/2022",
    label: "Overview",
  },
  {
    key: "keynote",
    link: "/2022/keynote",
    label: "Keynote Speaker",
  },
  {
    key: "interactive",
    link: "/2022/interactive",
    label: "Interactive Sessions",
  },
  {
    key: "abstracts",
    link: "/2022/abstracts",
    label: "Project Abstracts",
  },
];

export default headerLinks;
